import React, { useEffect, useState } from "react";

import { FaChevronLeft, FaChevronRight, FaPlay, FaTimes } from "react-icons/fa";

import { BsBookmarkFill, BsFileTextFill } from "react-icons/bs";

import { MdKeyboardVoice, MdPhotoCamera, MdVideocam } from "react-icons/md";

import { useSwipeable } from "react-swipeable";

import { Link } from "react-router-dom";

import Voice from "../../components/Posts/Voice";

import Video from "../../components/Posts/Video";

import Photo from "../../components/Posts/Photo";

import PostInfo from "../../components/PostInfo";

import SaveInfo from "../../components/SaveInfo";

import { useUserContext } from "../../context/AuthContext";

import { getSavedPosts } from "../../api";

import { getMediaUrl } from "../../lib/utils";

const SavedPost = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const [savedPosts, setSavedPosts] = useState([]);

  const { authUser } = useUserContext();

  useEffect(() => {
    getSavedPosts().then((res) => setSavedPosts(Array.isArray(res.data) ? res.data : [])).catch((err) => console.error("Get saved posts error:", err));
  }, []);

  const handleOpen = (post) => {
    const index = savedPosts.findIndex((savedPost) => savedPost.id === post.id);

    setActiveIndex(index);
  };

  const handleClose = () => setActiveIndex(null);

  const handlePrev = () => setActiveIndex((prev) => prev > 0 ? prev - 1 : savedPosts.length - 1);

  const handleNext = () => setActiveIndex((prev) => prev < savedPosts.length - 1 ? prev + 1 : 0);

  const swipeHandlers = useSwipeable({ onSwipedLeft: handleNext, onSwipedRight: handlePrev, trackMouse: true });

  const getContents = (content) => {
    if (!content) return [];

    if (Array.isArray(content)) return content.filter(Boolean);

    return content.split(",").map((item) => item.trim()).filter(Boolean);
  };

  const getTypeLabel = (type) => {
    if (type === "photo") return "Photo";

    if (type === "video") return "Video";

    if (type === "voice") return "Voice";

    if (type === "text") return "Text";

    return "Post";
  };

  const getTypeIcon = (type) => {
    if (type === "photo") return <MdPhotoCamera size={14} />;

    if (type === "video") return <MdVideocam size={15} />;

    if (type === "voice") return <MdKeyboardVoice size={15} />;

    return <BsFileTextFill size={12} />;
  };

  const renderPhotoPreview = (post) => {
    const images = getContents(post.content);

    if (images.length === 1) {
      return <img src={getMediaUrl(images[0])} alt="Saved post" className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.02]" />;
    }

    return (
      <div className="grid h-full grid-cols-2 gap-1">
        <img src={getMediaUrl(images[0])} alt="Saved post" className="h-full w-full object-cover" />

        <div className="relative grid h-full grid-rows-2 gap-1">
          <img src={getMediaUrl(images[1])} alt="Saved post" className="h-full w-full object-cover" />

          {images[2] && <img src={getMediaUrl(images[2])} alt="Saved post" className="h-full w-full object-cover" />}

          {images.length > 3 && (
            <div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-lg bg-black/70 px-2 py-1 text-xs font-semibold text-white">
              <MdPhotoCamera size={13} />
              {images.length}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderCardContent = (post) => {
    if (post.type === "photo") {
      return (
        <div className="h-[260px] overflow-hidden bg-gray-100">
          {renderPhotoPreview(post)}
        </div>
      );
    }

    if (post.type === "video") {
      return (
        <div className="relative h-[250px] overflow-hidden bg-gray-950">
          <video src={getMediaUrl(getContents(post.content)[0])} preload="metadata" muted className="h-full w-full object-cover" />

          <div className="absolute inset-0 bg-black/10" />

          <div className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/70 bg-black/35 text-white shadow-lg backdrop-blur-sm">
            <FaPlay size={17} className="ml-1" />
          </div>

          <div className="absolute bottom-3 right-3 flex items-center gap-1 rounded-lg bg-black/65 px-2 py-1 text-[11px] font-medium text-white">
            <MdVideocam size={14} />
            Video
          </div>
        </div>
      );
    }

    if (post.type === "voice") {
      return (
        <div className="px-5 pb-2 pt-1">
          <div className="rounded-2xl border border-purple-100 bg-gradient-to-r from-purple-50 to-indigo-50 p-4">
            <div className="mb-3 flex items-center gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-purple-600 text-white">
                <FaPlay size={12} className="ml-0.5" />
              </div>

              <div className="flex h-10 flex-1 items-center gap-[3px] overflow-hidden">
                {Array.from({ length: 35 }).map((_, index) => <span key={index} className="w-[3px] shrink-0 rounded-full bg-purple-400" style={{ height: `${10 + ((index * 7) % 25)}px` }} />)}
              </div>

              <MdKeyboardVoice size={20} className="shrink-0 text-purple-500" />
            </div>

            <p className="text-xs font-medium text-purple-500">Voice post</p>
          </div>
        </div>
      );
    }

    return (
      <div className="h-[260px] p-5 pt-2">
        <div className="flex h-full items-center overflow-hidden rounded-2xl bg-gradient-to-br from-purple-50 via-white to-indigo-50 px-6 py-5">
          <p className="line-clamp-6 overflow-hidden text-[16px] leading-7 text-gray-700">{post.content || ""}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-7 sm:px-6 lg:px-8">

        {/* HEADER */}
        <div className="mb-6">
          <div className="flex items-start gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-purple-100 text-purple-600">
              <BsBookmarkFill size={20} />
            </div>

            <div>
              <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">Saved Posts</h1>

              <p className="mt-1 text-sm text-gray-500">All the posts you've saved, in one place.</p>
            </div>
          </div>
        </div>

        {/* EMPTY */}
        {savedPosts.length === 0 && (
          <div className="flex min-h-[430px] flex-col items-center justify-center rounded-3xl border border-dashed border-gray-200 bg-white px-6 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-purple-50 text-purple-500">
              <BsBookmarkFill size={24} />
            </div>

            <h2 className="mt-5 text-lg font-bold text-gray-900">No saved posts yet</h2>

            <p className="mt-2 max-w-sm text-sm leading-6 text-gray-500">Posts you save will appear here so you can easily find them again.</p>
          </div>
        )}

        {/* SAVED POSTS */}
        {savedPosts.length > 0 && (
          <div className="grid grid-cols-1 items-start gap-5 md:grid-cols-2 xl:grid-cols-3">
            {savedPosts.map((post) => (
              <article key={post.id} className="group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-md">

                {/* CREATOR */}
                <div className="flex items-center justify-between px-5 py-4">
                  <Link to={`/profile/${post.creator_id}`} onClick={(e) => e.stopPropagation()} className="flex min-w-0 items-center gap-3">
                    <img src={getMediaUrl(post.profile_img)} alt={`${post.firstname} ${post.lastname}`} className="h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-gray-200" />

                    <div className="min-w-0">
                      <p className="truncate text-sm font-semibold text-gray-900">{post.firstname} {post.lastname}</p>

                      <div className="mt-0.5 flex items-center gap-1.5 text-[11px] text-gray-400">
                        {getTypeIcon(post.type)}

                        <span>{getTypeLabel(post.type)} post</span>
                      </div>
                    </div>
                  </Link>

                  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple-50 text-purple-600">
                    <BsBookmarkFill size={13} />
                  </div>
                </div>

                {/* CONTENT */}
                <div className="cursor-pointer" onClick={() => handleOpen(post)}>
                  {renderCardContent(post)}
                </div>

                {/* INFO */}
                <div className="border-t border-gray-100 px-5 py-3">
                  <SaveInfo post={post} user={authUser} />
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      {/* POST VIEWER */}
      {activeIndex !== null && savedPosts[activeIndex] && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-3 backdrop-blur-sm sm:p-6" {...swipeHandlers}>

          {/* CLOSE */}
          <button type="button" onClick={handleClose} className="absolute right-4 top-4 z-[90] flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white hover:text-gray-900">
            <FaTimes size={16} />
          </button>

          {/* PREVIOUS */}
          {savedPosts.length > 1 && (
            <button type="button" onClick={handlePrev} className="absolute left-3 z-[90] flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white hover:text-gray-900 sm:left-6">
              <FaChevronLeft size={14} />
            </button>
          )}

          {/* MODAL */}
          <div className="flex max-h-[92vh] w-full max-w-4xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl">

            {/* MODAL HEADER */}
            <div className="flex shrink-0 items-center justify-between border-b border-gray-100 bg-white px-5 py-4">
              <Link to={`/profile/${savedPosts[activeIndex].creator_id}`} className="flex min-w-0 items-center gap-3">
                <img src={getMediaUrl(savedPosts[activeIndex].profile_img)} alt={`${savedPosts[activeIndex].firstname} ${savedPosts[activeIndex].lastname}`} className="h-10 w-10 rounded-full object-cover ring-1 ring-gray-200" />

                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-gray-900">{savedPosts[activeIndex].firstname} {savedPosts[activeIndex].lastname}</p>

                  <div className="mt-0.5 flex items-center gap-1.5 text-xs text-gray-400">
                    {getTypeIcon(savedPosts[activeIndex].type)}

                    <span>{getTypeLabel(savedPosts[activeIndex].type)} post</span>
                  </div>
                </div>
              </Link>

              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-purple-50 text-purple-600">
                <BsBookmarkFill size={14} />
              </div>
            </div>

            {/* MODAL CONTENT */}
            <div className={`flex min-h-0 flex-1 items-center justify-center overflow-y-auto p-4 sm:p-6 ${savedPosts[activeIndex].type === "text" || savedPosts[activeIndex].type === "voice" ? "bg-gray-50" : "bg-gray-950"}`}>
              <div className="w-full max-w-3xl">

                {savedPosts[activeIndex].type === "photo" && <Photo content={savedPosts[activeIndex].content} />}

                {savedPosts[activeIndex].type === "video" && <Video content={savedPosts[activeIndex].content} largeScreen={false} />}

                {savedPosts[activeIndex].type === "text" && (
                  <div className="max-h-[60vh] overflow-y-auto rounded-2xl bg-white p-6 text-[16px] leading-7 text-gray-700 shadow-sm sm:p-8">
                    {savedPosts[activeIndex].content}
                  </div>
                )}

                {savedPosts[activeIndex].type === "voice" && (
                  <div className="rounded-2xl bg-white p-5 shadow-sm sm:p-6">
                    <div className="mb-5 flex items-center gap-3">
                      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-100 text-purple-600">
                        <MdKeyboardVoice size={20} />
                      </div>

                      <div>
                        <p className="text-sm font-semibold text-gray-900">Voice post</p>

                        <p className="mt-0.5 text-xs text-gray-400">Listen to the original audio</p>
                      </div>
                    </div>

                    <Voice url={savedPosts[activeIndex].content} postId={savedPosts[activeIndex].id} />
                  </div>
                )}
              </div>
            </div>

            {/* POST ACTIONS */}
            <div className="shrink-0 border-t border-gray-100 bg-white px-5 py-3">
              <PostInfo post={savedPosts[activeIndex]} user={authUser} />
            </div>
          </div>

          {/* NEXT */}
          {savedPosts.length > 1 && (
            <button type="button" onClick={handleNext} className="absolute right-3 z-[90] flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-md transition hover:bg-white hover:text-gray-900 sm:right-6">
              <FaChevronRight size={14} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SavedPost;